import { createSelector } from "@ngrx/store";

import { RegistrationFeatureState } from "../../state";

import { RegistrationWithCepState } from "./registration-with-cep.model";

export namespace RegistrationWithCepSelector {
	export const getState = (state: RegistrationFeatureState) => state.registrationFeature.registrationWithCep;

	export const isBusy = createSelector(getState, (state: RegistrationWithCepState) => state.isBusy);

	export const success = createSelector(getState, (state: RegistrationWithCepState) => state.success);
}
